var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.26 22.0004C15.2 22.0004 15.13 21.9904 15.07 21.9704C13.06 21.4004 10.95 21.4004 8.93997 21.9704C8.56997 22.0704 8.17997 21.8604 8.07997 21.4904C7.96997 21.1204 8.18997 20.7304 8.55997 20.6304C10.82 19.9904 13.2 19.9904 15.46 20.6304C15.83 20.7404 16.05 21.1204 15.94 21.4904C15.84 21.8004 15.56 22.0004 15.26 22.0004Z",
    fill: "#4E7E77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.21 6.35952C18.17 4.25952 16.16 2.70952 13.83 2.19952C11.39 1.65952 8.88997 2.23952 6.97997 3.77952C5.05997 5.30952 3.96997 7.59952 3.96997 10.0495C3.96997 12.6395 5.51997 15.3495 7.85997 16.9195V17.7495C7.84997 18.0295 7.83997 18.4595 8.17997 18.8095C8.52997 19.1695 9.04997 19.2095 9.45997 19.2095H14.59C15.13 19.2095 15.54 19.0595 15.82 18.7795C16.2 18.3895 16.19 17.8895 16.18 17.6195V16.9195C19.28 14.8295 21.23 10.4195 19.21 6.35952ZM13.72 11.6195L12.65 13.4795C12.51 13.7195 12.26 13.8595 12 13.8595C11.87 13.8595 11.74 13.8295 11.63 13.7595C11.27 13.5495 11.15 13.0895 11.35 12.7395L12.2 11.2595H11.36C10.86 11.2595 10.45 11.0395 10.23 10.6695C10.01 10.2895 10.03 9.82952 10.28 9.38952L11.35 7.52952C11.56 7.16952 12.02 7.04952 12.37 7.24952C12.73 7.45952 12.85 7.91952 12.65 8.26952L11.8 9.74952H12.64C13.14 9.74952 13.55 9.96952 13.77 10.3395C13.99 10.7195 13.97 11.1895 13.72 11.6195Z",
    fill: "#4E7E77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.3e522696e270eabd1939e70fd22610f6.svg";
export { ForwardRef as ReactComponent };